module.exports = __webpack_public_path__ + "img/promo2.4c72a4d4.png";